const DocECMDocumentIntelligenceProvider = {
    AzureAI: 1,
    AutorecognitionAPI: 2,
    Infomaniak: 3,
    Fixed: 4
};

export default DocECMDocumentIntelligenceProvider;
